<div
  [ngClass]="[
    'p-flight-detail01__item p-flight-detail01__item--2col p-flight-detail01__item--wait',
    tripSummarySvc.isOtherClass(flight.operatingAirlineCode)
  ]"
>
  <div class="p-flight-detail01__time">
    <!-- (1.1.41) フライト時間 - 当該セグメント情報.durationを表示する。-->
    <div *ngIf="!flight.isOpenSegment" class="p-flight-detail01__time-item">
      <span
        class="p-flight-detail01__time-elapsed"
        [innerHTML]="flightDuration | dateFormat : 'default_flightTotalTime'"
      ></span>
    </div>
  </div>
  <div class="p-flight-detail01__detail">
    <div class="p-flight-detail01__detail-item">
      <dl class="p-flight-detail01__detail-info">
        <div *ngIf="!flight.isOpenSegment" class="p-flight-detail01__detail-info-item">
          <dt class="p-flight-detail01__detail-info-title" [innerHTML]="'label.flightName' | staticMsg"></dt>
          <dd class="p-flight-detail01__detail-info-contents">
            <div class="c-flight-detail-overview01">
              <div class="c-flight-detail-overview01__item">
                <!-- (1.1.27) 便名
                  当該セグメント情報.marketingAirlineCode +
                  当該セグメント情報.marketingFlightNumber を表示する。-->
                <strong innerHTML="{{ flight.marketingAirlineCode }}{{ flight.marketingFlightNumber }}"></strong>
              </div>
              <!-- (1.1.28) 運航キャリア識別
                1) 当該セグメント情報.isNhGroupOperated=true (NHグループ運航便)の場合、
                   ANAのアイコンを表示する。-->
              <div
                *ngIf="flight.operatingAirlineCode === appConstants.CARRIER.TWO_LETTER"
                class="c-flight-detail-overview01__item"
              >
                <span class="c-ana-icon01">
                  <img
                    class="c-ana-icon01__img"
                    src="{{ appConstants.IMG.LOGO_S }}"
                    width="{{ appConstants.IMG.LOGO_S_WIDTH }}"
                    height="{{ appConstants.IMG.LOGO_S_HEIGHT }}"
                    [alt]="'alt.nhFlight' | staticMsg"
                  />
                </span>
              </div>
            </div>
          </dd>
        </div>
        <div *ngIf="!flight.isOpenSegment && isDisplayCarrierName" class="p-flight-detail01__detail-info-item">
          <dt class="p-flight-detail01__detail-info-title" [innerHTML]="'label.operate' | staticMsg"></dt>
          <dd class="p-flight-detail01__detail-info-contents">
            <span class="c-asam-icon01 c-asam-icon01--large">
              <!-- (1.1.28) 運航キャリア識別 -->
              <!-- (1.1.29) 運航キャリア名称 -->
              <span class="c-asam-icon01__text">
                <!-- 提携: 運航キャリア名称とそれに紐づくURLがキャッシュに存在する場合 -->
                <ng-container *ngIf="showOperatingCarrierName">
                  <a
                    id="{{ id }}_airline_url"
                    class="p-flight-detail01__item-text-link"
                    [href]="carrierUrl"
                    target="_blank"
                  >
                    <span
                      class="p-flight-detail01__detail-info-supp"
                      aria-hidden="true"
                      [innerHTML]="'label.operate' | staticMsg"
                    ></span>
                    {{ carrierName }}
                    <img
                      class="c-text-link-external"
                      src="{{ appConstants.IMG.S01_P030_S01_U__ANOTHER_WINDOW }}"
                      width="16"
                      height="16"
                      [alt]="'alt.anotherWindow' | staticMsg"
                    />
                  </a>
                </ng-container>
                <ng-container *ngIf="!showOperatingCarrierName">
                  <span
                    class="p-flight-detail01__detail-info-supp"
                    aria-hidden="true"
                    [innerHTML]="'label.operate' | staticMsg"
                  ></span>
                  <!-- 提携: 運航キャリア名称キャッシュに存在する場合はcarrireNameを表示、存在しない場合はoperatingAirlineNameを表示する -->
                  {{ carrierName || operatingAirlineName }}
                </ng-container>
              </span>
              <!-- /(1.1.29) 運航キャリア名称 -->
            </span>
          </dd>
        </div>
        <div *ngIf="!flight.isOpenSegment" class="p-flight-detail01__detail-info-item">
          <dt
            class="p-flight-detail01__detail-info-title"
            [innerHTML]="'label.itineraryDetailsBoarding' | staticMsg"
          ></dt>
          <!-- (1.1.30) 機種コード -->
          <dd class="p-flight-detail01__detail-info-contents">
            <!-- 1.2) 機種URLが存在する場合、機種URLで当該セグメント情報.aircraftCodeを表示する
              上記以外の場合、ラベルで当該セグメント情報.aircraftCodeを表示する。-->
            <ng-container *ngIf="getAircraft(); let aircraft">
              <a
                *ngIf="deviceType !== 'SP' && aircraft.url; else aircraftText"
                id="{{ id }}_aircraft"
                class="p-flight-detail01__item-text-link"
                [href]="aircraft.url | metaUrl"
                target="_blank"
              >
                <ng-container [ngTemplateOutlet]="aircraftText"></ng-container>
                <img
                  class="c-text-link-external"
                  src="{{ appConstants.IMG.S01_P030_S01_U__ANOTHER_WINDOW }}"
                  width="16"
                  height="16"
                  [alt]="'alt.anotherWindow' | staticMsg"
                />
              </a>
              <ng-template #aircraftText>
                <div [outerHTML]="aircraft.name"></div>
              </ng-template>
            </ng-container>
          </dd>
        </div>
        <!-- (1.1.32) 座席指定状況 -->
        <div *ngIf="!flight.isOpenSegment" class="p-flight-detail01__detail-info-item">
          <dt class="p-flight-detail01__detail-info-title" [innerHTML]="'label.seat' | staticMsg"></dt>
          <dd class="p-flight-detail01__detail-info-contents">
            <!-- 3) PNR情報取得API応答.data.orderEligibilities.seatmap.isEligible=true、
              当該セグメント情報.idをパラメータとしたシートマップ(S03-P010)へ遷移するリンクとする。-->
            <a
              *ngIf="isSeatmapEligible; else seatmapText"
              id="{{ id }}_link-to-seatmap"
              class="p-flight-detail01__item-text-link"
              href="javascript:void(0)"
              (click)="clickSeatReservationStatus()"
            >
              <ng-container *ngTemplateOutlet="seatmapText"></ng-container>
              <img
                class="c-text-link-external"
                src="{{ appConstants.IMG.S01_P030_S01_U__ANOTHER_WINDOW }}"
                width="16"
                height="16"
                [alt]="'alt.anotherWindow' | staticMsg"
              />
            </a>
            <ng-template #seatmapText>
              <span
                class="p-flight-detail01__detail-info-supp"
                aria-hidden="true"
                [innerHTML]="('label.seat' | staticMsg) + ('label.colon' | staticMsg)"
              ></span>
              <div [outerHTML]="getSeatNumberList()"></div>
            </ng-template>
          </dd>
        </div>
        <!-- (1.1.33) ステータス & (1.1.16) セグメント情報 (2.7) -->
        <div class="p-flight-detail01__detail-info-item">
          <dt class="p-flight-detail01__detail-info-title" [innerHTML]="'label.reservationStatus1' | staticMsg"></dt>
          <dd class="p-flight-detail01__detail-info-contents">
            <span
              class="p-flight-detail01__detail-info-supp"
              aria-hidden="true"
              [innerHTML]="('label.reservationStatus1' | staticMsg) + ('label.colon' | staticMsg)"
            ></span>
            <ng-container *ngIf="getStatus(); let status">
              <div *ngIf="!status.style" [outerHTML]="status.label | staticMsg"></div>
              <strong *ngIf="status.style" style="color: red" [innerHTML]="status.label | staticMsg"></strong>
            </ng-container>
          </dd>
        </div>
        <div
          *ngIf="!flight.isOpenSegment && flight.isNhGroupOperated"
          class="p-flight-detail01__detail-info-item p-flight-detail01__detail-info-item--service"
        >
          <dt class="p-flight-detail01__detail-info-title" [innerHTML]="'label.InFlightService' | staticMsg"></dt>
          <!-- (1.1.34) 提供サービスアイコン - 当該セグメント情報.isNhGroupOperated=true(NHグループ運航)の場合、提供サービスアイコンを表示する。-->
          <dd *ngIf="flight.isNhGroupOperated" class="p-flight-detail01__detail-info-contents">
            <asw-in-flight-service [boundIdx]="boundIdx" [flightIdx]="flightIdx"></asw-in-flight-service>
          </dd>
        </div>
        <div *ngIf="!flight.isOpenSegment && isShowACV" class="p-flight-detail01__detail-info-item">
          <dt class="p-flight-detail01__detail-info-title" [innerHTML]="'label.equipment' | staticMsg"></dt>
          <!-- (1.1.42) ACVに応じたラベルもしくは画像 -->
          <dd *ngIf="isShowACV" class="p-flight-detail01__detail-info-contents">
            <div class="c-flight-detail-overview01">
              <div class="c-flight-detail-overview01__2col">
                <div class="c-flight-detail-overview01__2col-left">
                  <!-- 2) ACV特性案内文言キーリストの件数>0の場合、そのACV特性案内文言キーリストを繰り返し、当該ACV特性案内文言キーを表示する -->
                  <ng-container *ngFor="let key of aircraftCabinMaster.acvCharacteristicMessageKeys ?? []; index as i">
                    <div *ngIf="key" [ngSwitch]="key" class="c-flight-detail-overview01__2col-left-item">
                      <ng-container *ngSwitchCase="'label.productName.backFacingSeat.first'">
                        <div [outerHTML]="'label.productName.backFacingSeat.first' | staticMsg"></div>
                        <div [outerHTML]="'link.productName.backFacingSeat.first' | staticMsg"></div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'label.productName.backFacingSeat.business'">
                        <!--
                        ※当該ACV特性案内文言キー="label.productName.backFacingSeat.business"「The Room」を表示する際、ヘルプアイコン(ツールチップ有り＋リンク有り)を表示する。
                        リンク:  当該セグメント情報.aircraftConfigurationVersionを基に「イベントID(1)」で取得したキャビンクラス別機材情報リストをフィルタして、プロダクトURLを取得する。
                        -->
                        <div [outerHTML]="'label.productName.backFacingSeat.business1' | staticMsg"></div>
                        <asw-tooltip
                          [iconImage]="
                            tripSummarySvc.buildTooltipIcon(
                              'icon_help_primary_20.svg',
                              'alt.helpIcon2' | staticMsg,
                              '20'
                            )
                          "
                          [tooltipContent]="'tooltip.productName.backFacingSeat.business' | staticMsg"
                        ></asw-tooltip>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div [outerHTML]="key | staticMsg"></div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</div>
